import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';


import Step3PreUpload from './Step3PreUpload';
import Step3SuccessUpload from './Step3SuccessUpload';
import { updateUser } from '../../../modules/user';
import { updateHouse } from '../../../modules/house';

/**
 * This is the entry point for Step3.  Step3 has a few different states
 * depending on the user's actions.
 *
 * Prior to uploading a spreadsheet file, they will be in the "new" uploadState.
 * They will remain in this "new" uploadState until all upload errors are resolved.
 *
 * Once the spreadsheet successfully uploads - they will be moved into the "success"
 * uploadState where the user will no longer see the dropzone, and now
 * see the table of lots they have uploaded.
 */
class Step3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadState: 'new'
    };
  }

  // The upload was successful - move to the "success" state
  handleUpload = (lots, spreadsheetErrors, spreadsheetWarnings) => {
    this.setState({
      lots,
      spreadsheetErrors,
      spreadsheetWarnings,
      uploadState: 'success'
    });
  };

  // Reset the state back to 'new' so the user can upload a new spreadsheet
  goBackToUpload = () => {
    this.setState(
      {
        lots: null,
        uploadState: 'new'
      },
      () => {
        window.scrollTo(0, 0);
      }
    );
  };

  render() {
    const { lots, spreadsheetErrors, spreadsheetWarnings, uploadState } = this.state;
    const { house } = this.props;
    // validate user missing the correct connectType (platinum (e) or gold (p))
    const ycConnectTypes = ['e', 'p'];
    const isPlatinumGold = ycConnectTypes.indexOf(house.connectType) !== -1;

    if (uploadState === 'success') {
      return (
        <Step3SuccessUpload
          goBackToUpload={this.goBackToUpload}
          lots={lots}
          spreadsheetErrors={spreadsheetErrors}
          spreadsheetWarnings={spreadsheetWarnings}
          isGoldPlatinum={isPlatinumGold}
          isInvaluableShippingEnabled={!!this.props.policy?.id}
        />
      );
    }

    return <Step3PreUpload handleUpload={this.handleUpload} />;
  }
}

const mapStateToProps = ({ user, house, policy }) => ({
  user,
  house,
  policy
});

const mapDispatchToProps = {
  updateUser,
  updateHouse
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Step3)
);
